module.exports = __webpack_public_path__ + "img/Patch14-3.104296f1.webp";